import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import api from './mixins/api'

Vue.mixin(api);

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
	moment,
});
import cordovaDialogs from "./mixins/cordovaDialogs";

Vue.mixin(cordovaDialogs);


// Bug tracker
/*
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
	apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
	plugins: [new BugsnagPluginVue()],
	enabledReleaseStages: ['production', 'staging'],
	releaseStage: process.env.NODE_ENV
})
const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue)
*/

// Global Mixins
// import ApiHelper from './mixins/api-helper'
// Vue.mixin(ApiHelper);

// Plugins
// import axios from 'axios'
// import VueAxios from 'vue-axios'
//
// Vue.use(VueAxios, axios)


// import VueToast from 'vue-toast-notification';
// // Import one of the available themes
// //import 'vue-toast-notification/dist/theme-default.css';
// import 'vue-toast-notification/dist/theme-sugar.css';

// Vue.use(VueToast);

import dayjs from "dayjs";
import locale_de from "dayjs/locale/de"

dayjs.locale(locale_de) //TODO locale dynamisch laden

// Vue config
Vue.config.productionTip = process.env.NODE_ENV === "production";
Vue.config.silent = process.env.NODE_ENV === "production";
// ----------------------

document.addEventListener('deviceready', async function () {
	let config = {};
	
	
	let defaultConfig = {};
	try {
		defaultConfig = await fetchConfigFile("./config/app-config.default.json")
	} catch (e) {
		window.debugLog("default config file not found: ", e);
	}
	
	let localConfig = {};
	try {
		localConfig = await fetchConfigFile(["./config/app-config", process.env.NODE_ENV, "json"].join('.'))
	} catch (e) {
		window.debugLog("local config file not found: ", e);
	}
	
	Object.assign(config, process.env, defaultConfig, localConfig);
	Object.seal(config);
	
	window.Config = config;
	Vue.prototype.$config = config;
	
	window.myApp = new Vue({
		router,
		store,
		i18n,
		render: h => h(App)
	}).$mount('#app')
	
});

function fetchConfigFile(file) {
	return process.env.NODE_ENV === "development" ?
		fetch(file).then(response => response.json()).catch(err => console.log(err))
		: window.fetchLocalResource(file)
}

window.fetchLocalResource = function (url) {
	return new Promise((resolve, reject) => {
		const req = new XMLHttpRequest();
		req.onload = function () {
			const text = req.responseText;
			resolve(JSON.parse(text))
			// Do something with text...
		};
		req.onerror = function () {
			reject('local fetch failed.')
		};
		req.open('GET', url);
		req.send();
	});
}


if (process.env.NODE_ENV === "production") {
	let nullFunc = () => null; //TODO prüfen
	window.console.log = nullFunc
	window.console.warn = nullFunc
	window.debugLog = nullFunc
	
	document.dispatchEvent(new CustomEvent("deviceready"))
} else if (process.env.NODE_ENV === "development") {
	window.debugLog = console.log;
	console.log('development mode ✅');
	console.log('Vue.config', Vue.config);
	
	document.dispatchEvent(new CustomEvent("deviceready"))
} else if (process.env.VUE_APP_WAIT_FOR_DEVICE !== "true") {
	document.dispatchEvent(new CustomEvent("deviceready"))
}
